import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/illus-home.png'


const _withScopeId = n => (_pushScopeId("data-v-66865aa3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed top-0 left-0 bottom-0 right-0 overflow-x-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-3/4 py-4" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Edit job members", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = { class: "flex flex-row justify-between space-x-3" }
const _hoisted_10 = { class: "w-5/12" }
const _hoisted_11 = { class: "w-5/12" }
const _hoisted_12 = { class: "w-2/12 flex justify-end" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex flex-col justify-between items-center" }
const _hoisted_16 = { class: "w-full whitespace-nowrap mt-12" }
const _hoisted_17 = ["onChange", "value"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "collaborator" }, "collaborator", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "responsible" }, "responsible", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 text-gray-400 animate-spin\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-66865aa3><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"6\" data-v-66865aa3></line><line x1=\"12\" y1=\"18\" x2=\"12\" y2=\"22\" data-v-66865aa3></line><line x1=\"4.93\" y1=\"4.93\" x2=\"7.76\" y2=\"7.76\" data-v-66865aa3></line><line x1=\"16.24\" y1=\"16.24\" x2=\"19.07\" y2=\"19.07\" data-v-66865aa3></line><line x1=\"2\" y1=\"12\" x2=\"6\" y2=\"12\" data-v-66865aa3></line><line x1=\"18\" y1=\"12\" x2=\"22\" y2=\"12\" data-v-66865aa3></line><line x1=\"4.93\" y1=\"19.07\" x2=\"7.76\" y2=\"16.24\" data-v-66865aa3></line><line x1=\"16.24\" y1=\"7.76\" x2=\"19.07\" y2=\"4.93\" data-v-66865aa3></line></svg>", 1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6 text-red-400\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-66865aa3><polyline points=\"3 6 5 6 21 6\" data-v-66865aa3></polyline><path d=\"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\" data-v-66865aa3></path><line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\" data-v-66865aa3></line><line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\" data-v-66865aa3></line></svg>", 1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "bg-gray-100 flex flex-col justify-center items-center p-4 mt-10 rounded-lg"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "160",
  alt: ""
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-6 font-medium" }, "Job members no added", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "bg-black opacity-50 fixed top-0 left-0 bottom-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  class: "text-gray-400 rounded-full hover:bg-pink-200 hover:text-red-400 p-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.jobMember,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.jobMember) = $event)),
                      options: _ctx.optionMembers,
                      label: "user_name",
                      placeholder: "Select collaborator",
                      reduce: (user) => user.id
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.memberRole,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberRole) = $event)),
                      options: ['collaborator', 'responsible'],
                      label: "user_name",
                      placeholder: "Select role"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn-filled-sm flex flex-row items-center justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in disabled:opacity-50 disabled:cursor-not-allowed",
                      disabled: _ctx.jobMember === '' || _ctx.memberRole === '',
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args)))
                    }, " Add member ", 8, _hoisted_13)
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.jobMembers.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("table", _hoisted_16, [
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobMembers, (member, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "focus:outline-none h-16 border-b border-gray-100 rounded",
                                key: index
                              }, [
                                _createElementVNode("td", null, _toDisplayString(member.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(member.user.email), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("select", {
                                    name: "members",
                                    class: "bg-gray-100 py-2 px-4 rounded",
                                    onChange: ($event: any) => (_ctx.onSelectChange($event, member.id)),
                                    value: member.role
                                  }, _hoisted_20, 40, _hoisted_17)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", null, [
                                    (member.id === _ctx.auxId)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _hoisted_23))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.deleteJobMember(member.id))
                                        }, _hoisted_26, 8, _hoisted_24))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31))
      : _createCommentVNode("", true)
  ], 64))
}